<template>
  <div id="admin-property-view" class="property-view">
    <v-row no-gutters>
      <v-col md="12">
        <property-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

export default {
  components: {
    PropertyTable: () => import("@/components/property/PropertyTable.vue")
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
